module.exports = "pegasus/assets/square-linkedin.png";